import React from "react";
import { url } from "../Functionalities/Config";
import image from "../Assets/images/profile_icon.jpg";


function CommentListingDelivery({ review }) {
    // void 0

    const rateditems = [];
    const rate = review.rating.toFixed(0);
    for (let i = 0; i < rate; i++) {
        rateditems.push(<i className="fa fa-star text-primary" />);
    }

    const notrateditems = [];
    for (let i = 0; i < 5 - rate; i++) {
        notrateditems.push(<i className="fa fa-star text-gray" />);
    }


    return (
        <div className="media review-box">
            {review.voter.images != null ? (
                <img
                    className="mr-3 img-fluid btn-rounded"
                    width={55}
                    height={55}
                    src={url + review.voter.images.image}
                    alt="Foodoor"
                />
            ) : (
                <img
                    className="mr-3 img-fluid btn-rounded"
                    width={55}
                    height={55}
                    src={image}
                    alt="Foodoor"
                />
            )}
            <div className="media-body">
                <a href={`/customerID/${review.voter.id}`}><h4 className="mt-0 mb-0 text-black">{review.voter.first_name}</h4></a>
                <ul className="review-meta mb-3 d-block d-sm-flex align-items-center">
                    <li className="mr-3">
                        <small>{new Date(review.review_time).toDateString()}</small>
                    </li>
                    {/* <li className="mr-3">
                        <small>Product : {review.item_name}</small>
                    </li> */}
                </ul>

                <p className="mb-3 text-secondary">{review.review}</p>
            </div>

            <div className="media-footer align-self-center">
                <div className="star-review text-md-center">
                    <span className="text-secondary">{rate}</span>
                    {rateditems}
                    {notrateditems}
                </div>
            </div>
        </div>
    )
}

export default CommentListingDelivery

